import React, { useRef, useState } from "react";

const UploadIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="#5f3c96" strokeWidth="2">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DEFAULT_SAFE_FILE_ACCEPT = ".xlsx,.xls,.csv,.pdf";

const UploadCard = ({ data, onFileSelected, disabled, acceptedFormats = DEFAULT_SAFE_FILE_ACCEPT }) => {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);
  const zoneStateClass = [
    "upload-zone",
    dragOver ? "upload-zone--over" : "",
    disabled ? "upload-zone--disabled" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) onFileSelected(file);
    e.target.value = "";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (disabled) return;
    const file = e.dataTransfer.files?.[0];
    if (file) onFileSelected(file);
  };

  const handleClick = () => {
    if (!disabled) inputRef.current?.click();
  };

  return (
    <div className="upload-card">
      <div
        className={zoneStateClass}
        onClick={handleClick}
        onDragEnter={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragOver={(e) => e.preventDefault()}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
      >
        <div className="upload-icon">
          <UploadIcon />
        </div>
        <div className="upload-text">
          <strong>{data?.Title || "Upload File"}</strong>
          <small>{data?.Subtitle || "Drag and drop or click to browse XLSX, XLS, CSV, or PDF files."}</small>
        </div>
        <input
          ref={inputRef}
          type="file"
          accept={acceptedFormats}
          hidden
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default UploadCard;
